const roleCheck = (user:any,rolesToCheck:string[]): boolean => {
    return user?.roles?.some((role: any) =>rolesToCheck.includes(role.name)) || false;
};

export default roleCheck;
